'use client';

import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { QuickActions } from './quick-actions';

interface SlidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
  showQuickActions?: boolean;
}

export function SlidePanel({ 
  isOpen, 
  onClose, 
  title = 'Quick Actions',
  children,
  showQuickActions = true
}: SlidePanelProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/20 z-40"
          onClick={onClose}
        />
      )}
      
      {/* Panel */}
      <div 
        className={`
          fixed right-0 top-0 h-full w-[380px] bg-black text-white
          transform transition-transform duration-200 ease-in-out z-50 shadow-xl
          ${isOpen ? 'translate-x-0' : 'translate-x-full'}
        `}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <div className="flex items-center gap-4">
            <h2 className="text-xl font-semibold">{title}</h2>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={onClose}
              className="p-2 rounded-full hover:bg-white/10 transition"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="h-[calc(100%-65px)] overflow-y-auto scrollbar-hide">
          {showQuickActions ? <QuickActions /> : children}
        </div>
      </div>
    </>
  );
}
